import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as SearchIcon } from '@/assets/icons/search.svg';
import {
  DeploymentDAGExplorerBaseUrl,
  DeploymentMetagraphId
} from '@/common/consts/api.ts';

import styles from './component.module.scss';

const TransactionHashPattern = /^[0-9a-fA-F]{64}$/;

const SnapshotOrdinalPattern = /^\d+$/;

const DeviceIdPattern = /^[0-9a-fA-F]+$/;

export const SearchBar = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const doSearch = () => {
    const trimmedSearch = search.trim();

    if (TransactionHashPattern.test(trimmedSearch)) {
      location.href = `${DeploymentDAGExplorerBaseUrl}/metagraphs/${DeploymentMetagraphId}/transactions/${trimmedSearch}`;
      return;
    }

    if (SnapshotOrdinalPattern.test(trimmedSearch)) {
      navigate(`/snapshots/${trimmedSearch}`);
      return;
    }

    if (DeviceIdPattern.test(trimmedSearch)) {
      navigate(`/devices/${trimmedSearch}`);
      return;
    }

    window.location.reload();
  };

  return (
    <div className={styles.main}>
      <div className={styles.searchIcon} onClick={doSearch}>
        <SearchIcon />
      </div>
      <input
        placeholder="Search by transactions, ordinal, device..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && doSearch()}
      />
    </div>
  );
};
